<script>
  import config from '../../libs/config.json';
	import { mapGetters, mapActions } from 'vuex'
	
	export default 
	{
		name: 'OnboardingUpcoming',
		data() 
        {
        	return {}
        },
        computed: {
          ...mapGetters('session', ['getUser'])
        },
      methods: {
        ...mapActions('session', ['setUser']),
        ...mapActions('htmlModals', ['setOnboardingUpcoming'])
      },
        created(){
        }
	}
</script>

<template>
<div  style="position: fixed; top: 0; right: 0; bottom: 0; left:0; background: rgba(15, 17, 26, 0.55) none repeat scroll 0% 0%; z-index: 9999; overflow: scroll;"
v-cloak>
    <div style="margin: 30px 0;" class="ui container">
        <div data-aos="fade-zoom-in" class="twelve wide computer sixteen wide mobile column centered">
            <div class="ui grid stackable">
                <div style="background: #fbfbfb;box-shadow: 0px 2px 54px rgba(39, 39, 39, 0.85);padding: 0; border-radius:5px;" class="seven wide computer sixteen wide mobile centered column">
                    <div style="overflow: hidden; height: 220px;" class="ui basic segment">
                                            <img style="border-radius: 5px; " class="ui fluid image" :src="'https://media1.giphy.com/media/4J1R8yQIRiCOc/giphy.gif?cid=3640f6095bca1dfa576f7856517ec59b'" alt="">
                    </div>
                    <div class="ui basic segment large lineSpecial">
                    <h2 class="ui header">Dear curious & brave <span style="cursor:help;" title="Juphyrian is a person who signed up to Juphy and they care about their customers!" data-tooltip="Juphyrian is a person who signed up to Juphy." data-inverted="">Juphyrian,</span></h2>
                    <p>We're working hard to make Juphy a complete social customer service solution! We always need your support and feedback to be the best tool!</p>
                    <h3>Upcoming features;</h3>
                    <ul class="ui list">
                        <li> <b>Instagram integration</b><div class="ui left pointing label">Availeable at Sep 30, 2018</div></li>
                        <li><b>Advanced Slack integration;</b> you will get notifications and be able to reply social messages directly without leaving your Slack workspace <div class="ui top pointing label">Availeable at Nov 30, 2018</div></li>
                        <li><b>YouTube integration</b> provides you to engage with your audience on your YouTube Video's Comments<div class="ui left pointing label">Availeable at Nov 30, 2018</div></li>
                    </ul>
                    <div @click="setOnboardingUpcoming(false)" class="ui button fluid"> Exit </div>
                    </div>
                </div>
            </div>
        </div>
    </div>      
</div>      
</template>

<style scope>
ul.ui.list li {
    line-height: 1.7em !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/OnboardingUpcoming.vue